/** Planos VIP — front (preços em BRL). Role/LP vêm do server via env. */

export const VIP_PLANS = {
  free: {
    id: 'free',
    name: 'Grátis',
    tagline: 'Comece a aventura',
    accent: 'stone',
    price: { monthly: 0, annual: 0 },
    paid: false,
  },
  origin: {
    id: 'origin',
    name: 'Origin',
    tagline: 'O equilíbrio perfeito',
    accent: 'violet',
    price: { monthly: 10, annual: 96 },
    paid: true,
  },
  eclipse: {
    id: 'eclipse',
    name: 'Eclipse',
    tagline: 'Poder de sobra',
    accent: 'indigo',
    price: { monthly: 20, annual: 192 },
    paid: true,
  },
  investidor: {
    id: 'investidor',
    name: 'Investidor',
    tagline: 'Patrocine o Nexus',
    accent: 'gold',
    price: { monthly: 30, annual: 288 },
    paid: true,
  },
};

/** Valores em centavos para Stripe */
export function getStripeAmountCents(planId, billing) {
  const plan = VIP_PLANS[planId];
  if (!plan || !plan.paid) return null;
  if (billing === 'annual') return Math.round(plan.price.annual * 100);
  return Math.round(plan.price.monthly * 100);
}

export function isValidMinecraftNick(nick) {
  return /^[A-Za-z0-9_]{3,16}$/.test(String(nick || '').trim());
}

export const PAID_PLAN_IDS = Object.keys(VIP_PLANS).filter((id) => VIP_PLANS[id].paid);
